import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M13.7121 16.5246C14.0782 16.1585 14.6718 16.1585 15.0379 16.5246L20 21.4867L24.9621 16.5246C25.3282 16.1585 25.9218 16.1585 26.2879 16.5246C26.654 16.8907 26.654 17.4843 26.2879 17.8504L20.6629 23.4754C20.2968 23.8415 19.7032 23.8415 19.3371 23.4754L13.7121 17.8504C13.346 17.4843 13.346 16.8907 13.7121 16.5246Z",
		fill: "#2171C6"
	})
});
export default SvgChevronDown;
